import React from "react";
import PropTypes from "prop-types";
import { ContentMenuLink } from "../Layout/templates";
import useCalculatorModal from "../../hooks/modalHooks/useCalculatorModal";
import CalculatorMenuModal from "./CalculatorMenuModal";

/**
 * Special link component for the main calculator menu in the app sidebar
 * Opens calculator menu page in modal when accessed from non-calculator contexts
 */
const CalculatorMenuLink = ({ children, className = "", ...props }) => {
  return (
    <ContentMenuLink
      contentType="calculator"
      className={className}
      useModalHook={useCalculatorModal}
      menuModalComponent={CalculatorMenuModal}
      {...props}
    >
      {children}
    </ContentMenuLink>
  );
};

CalculatorMenuLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default CalculatorMenuLink;
